/**------------------------------------------------------
 * Shared constants
 */
export enum EnumSearchType {
	Default		= 'default',
	Specific	= 'specific',
	MatchAll	= 'match_all'
}

export const MATCH_ALL_SEARCH_MAX_TERMS = 5;
